<template>
  <div>
    <form data-vv-scope="step-2-part-1">
      <div class="row mb-5" >
        <div class="col-12">
          <h4>Datos de la persona que ingresa el documento</h4>
        </div>
        <div class="col-md-12">
          <label for="creatorGroup">Grupo al que irá asociado el expediente (*)</label>
          <select-options
            name="creatorGroup"
            :alphabetical-sort="true"
            options-group="fisabs-requester-unit"
            v-model="step.creatorGroup"
            :danger="errors.has('step-2-part-1.creatorGroup')"
            :danger-text="errors.first('step-2-part-1.creatorGroup')"
            v-validate="'required'"
            data-vv-as="unidad requirente"
            data-cy="creator-group"
            ref="creatorGroup"
          />

        </div>
      </div>
      <div
        class="row mb-3"
        v-if="!isNumerationFile"
      >
        <div class="col-12">
          <h4>Origen / Datos Remitente</h4>
        </div>
      </div>
      <div v-if="!isNumerationFile" class="row mb-3">
        <div class="col-md-12">
          <list-groups
            class="w-100"
            autocomplete
            label="Dirección - Región"
            name="directionId"
            v-model="step.directionId"
            :danger="errors.has('step-2-part-1.directionId')"
            :danger-text="errors.first('step-2-part-1.directionId')"
            v-validate="'required'"
            ref="directionId"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-input
            class="w-100"
            label="Cargo Persona"
            maxlength="150"
            name="personPosition"
            v-model="step.personPosition"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-2-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4 v-if="company.iut === univAysen.iut && wizard === 'numOf'">Destinatario</h4>
          <h4 v-if="company.iut !== univAysen.iut">Destinatario (*)</h4>
        </div>
      </div>
      <SelectSubject
        :docTypeSelected="documentTypeSelected"
        @add-subject="addSubject"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            v-if="step.subjects"
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
          />
        </div>
      </div>
    </form>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    <form data-vv-scope="step-2-part-3">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Con copia a</h4>
        </div>
      </div>
      <SelectCopy @add-copy="addCopy" />
      <div class="row mb-3">
        <div class="col-12">
          <TableCopies
            :copies="step.copies"
            v-model="step.copiesSelected"
          />
        </div>
      </div>
    </form>
    <div class="row mb-3">
      <div class="col-12">
        <vs-divider />
      </div>
    </div>
    <form data-vv-scope="step-2-part-4">
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Acompaña Físico"
            name="esFisico"
            v-model="step.withAttachment"
          >
            <vs-select-item
              :value="0"
              text="No"
            />
            <vs-select-item
              :value="1"
              text="Si"
            />
          </vs-select>
        </div>
        <div class="col-md-6" v-if="step.withAttachment">
          <vs-input
            class="w-100"
            label="Detalle"
            maxlength="250"
            name="documentDetail"
            v-model="step.documentDetail"
            v-validate="{ required: step.withAttachment === 1 }"
            :danger="errors.has('step-2-part-4.documentDetail')"
            :danger-text="errors.first('step-2-part-4.documentDetail')"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <vs-input
            class="w-100"
            label="Resumen materia"
            maxlength="250"
            name="resumen"
            v-model="step.resumen"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="observation">Observacion (5000 caracteres)</label>
          <vs-textarea
            id="observation"
            maxlength="5000"
            label="Observacion (5000 caracteres)"
            name="observacion"
            v-model="step.observation"
            width="100%"
            height="100px"
          />
        </div>
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUserGroups from '@/febos/chile/lists/components/ListUserGroups';
import SelectSubject from '@/febos/chile/dnt/components/wizard/subjects/SelectSubject';
import SelectCopy from '@/febos/chile/dnt/components/wizard/subjects/SelectCopy';
import TableSubjects from '@/febos/chile/dnt/components/wizard/subjects/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/subjects/TableCopies';
import { U_AYSEN } from '@/constants/companies';
import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';

export default {
  mixins: [WizardStep],
  components: {
    ListGroups,
    ListUserGroups,
    SelectSubject,
    SelectCopy,
    SelectOptions,
    TableSubjects,
    TableCopies
  },
  data() {
    const { wizard } = this.$route.params;
    return {
      wizard,
      univAysen: U_AYSEN,
      error: {
        message: ''
      },
      emailRequired: ['personas', 'empresas', 'ministerios'],
      isInput: ['personas', 'empresas'],
      subjectForm: {
        subjectType: '',
        subject: '',
        subjectTypeDigitalDoc: '',
        subjectEmail: '',
      },
      copySubjectForm: {
        copySubjectType: '',
        copySubject: '',
        copySubjectTypeDigitalDoc: '',
        copySubjectEmail: '',
      },
      step: {
        responseFile: false,
        creatorGroup: '',
        directionId: '',
        personId: '',
        personPosition: '',
        withAttachment: 0,
        documentDetail: '',
        resumen: '',
        observation: '',
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        ...this.draft
      }
    };
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Dnts', [
      'wizardData',
      'documentTypeSelected'
    ]),
    ...mapGetters('List', [
      'userGroupsState'
    ]),
    isNumerationFile() {
      const { wizard } = this.$route.params;
      return wizard === 'numInt' || wizard === 'numOf';
    }
  },
  watch: {
    subjects(newValue) {
      this.subjectsSelected = newValue;
      this.subjects = newValue;
    },
    copies(newValue) {
      this.copiesSelected = newValue;
      this.copies = newValue;
    }
  },
  methods: {
    async addSubject(row) {
      if (row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });

      if (!isSelected) {
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async addCopy(row) {
      if (row.copySubject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      const isSelected = this.step.copiesSelected
        .some((copyRow) => {
          if (copyRow.copySubjectType.value === 'docDigital') return copyRow.copySubjectTypeDigitalDoc.id === row.copySubjectTypeDigitalDoc.id;

          return copyRow.copySubject.id === row.copySubject.id;
        });
      if (isSelected) {
        this.$bvToast.toast(
          'Ya agregaste esta copia',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }

      this.step.copies.push(row);
      this.step.copiesSelected.push(row);
    },
    async isValid() {
      const stepValidations = await Promise.all([
        this.validateForm('step-2-part-1'),
        this.validateForm('step-2-part-4'),
      ]);

      if (stepValidations.some((step) => !step)) {
        return false;
      }

      const { wizard } = this.$route.params;
      if (this.company.iut === U_AYSEN.iut && wizard === 'numOf') {
        console.log('no pedir destinatarios');
      } else if (!this.step.subjectsSelected.length) {
        this.error.message = 'Debes agregar al menos un destino';
        return false;
      }

      return true;
    },
    getStepData() {
      this.step.directionId = this.step.creatorGroup;

      const directionName = this.step.directionId
        ? {
          directionName: this.$refs.creatorGroup.getOption().label
        }
        : {};

      const creatorGroupName = this.step.creatorGroup
        ? {
          creatorGroupName: this.$refs.creatorGroup.getOption().label
        }
        : {};

      const creatorGroupId = this.step.creatorGroup && this.$refs.creatorGroup
        ? this.$refs.creatorGroup.getOption().id : '';
      return {
        ...directionName,
        ...creatorGroupName,
        ...creatorGroupId,
        ...this.step
      };
    }
  },
  created() {
    this.step.personName = this.currentUser.nombre;
    this.step.personId = this.currentUser.id;
    this.step.personPosition = this.currentUser.cargo || '';

    // Esto se usa desde un principio como descripción de flujo, no borrar
    this.step.resumen = (this.wizardData.matter || '').slice(0, 50);
  }
};

</script>
